import type { ButtonHTMLAttributes } from 'react';
import { AIconProps } from '../../atoms/AIcon/AIcon.types';

export enum MTabControlAlignment {
  Left = 'Left',
  Center = 'Center',
}

export type MTabControlProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  description?: string;
  showIcon?: boolean;
  aIcon?: Partial<AIconProps>;
  alignment?: MTabControlAlignment;
  active?: boolean;
  onClick?: () => void;
};
